import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { IPage } from '@core/interfaces/ipage';
import { PageService } from '@core/services/page.service';
import { take } from 'rxjs';

@Component({
    selector: 'app-hero-section',
    templateUrl: './hero-section.component.html',
    styleUrls: ['./hero-section.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeroSectionComponent implements OnInit {


  pageContent!: IPage;

  constructor(private page: PageService, private router: Router) {}

  ngOnInit(): void {
    this.getPageContent();

    const video = document.getElementById('video') as HTMLVideoElement;
    if (video) {
      video.muted = true;
      
      setTimeout(() => {
        video.play().catch((error) => {
          console.error('Autoplay failed: ', error);
        });
      }, 100);
    };
  };

  getPageContent(): void {
    const currentRoute = this.router.routerState.snapshot.url;
    this.page
      .getPageById(40) // and here
      .pipe(take(1))
      .subscribe((res: IPage) => {
        this.pageContent = res;
      });
  }
}
